import { render, staticRenderFns } from "./EditableList.vue?vue&type=template&id=8da6f190&scoped=true"
import script from "./EditableList.vue?vue&type=script&lang=js"
export * from "./EditableList.vue?vue&type=script&lang=js"
import style0 from "./EditableList.vue?vue&type=style&index=0&id=8da6f190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da6f190",
  null
  
)

export default component.exports